import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataQueryCategory } from '../models/data-query-category.model';
import { LoginService } from '../../../shared-modules/login/login.service';

@Component({
    selector: 'app-no-relationships-warning-dialog',
    templateUrl: './no-relationships-warning-dialog.component.html',
    styleUrls: ['./no-relationships-warning-dialog.component.css']
})
export class NoRelationshipsWarningDialogComponent implements OnInit {

    // Injected Properties
    unjoinedCategoryGroups: DataQueryCategory[][] = [];

    // Properties
    V10: boolean;

    // Class Functions
    constructor(
        private dialogBox: MatDialogRef<NoRelationshipsWarningDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private loginService: LoginService
    ) { }

    // Event Functions
    ngOnInit() {
        // POST: sets the injected properties
        this.unjoinedCategoryGroups = this.data.unjoinedCategoryGroups;
        this.V10 = this.loginService.LoginSettings.V10;
    }

    ok() {
        // PRE: the OK button is clicked
        // POST: closes the dialog box
        this.dialogBox.close();
    }

    // Methods
}
